import { ref } from "@vue/composition-api"
import { MONTHLY_SALES } from "../../utils/shop.utils"

const useRange = () => {
    const monthlySalesRange = ref()

    const setMonthlySalesRange = (monthlySales) => {
        const range = MONTHLY_SALES.filter(el => el.start < monthlySales && el.end > monthlySales)[0]
        if(range.end === 30000) {
            monthlySalesRange.value = `Under $${range.end}`
        } else if(range.start === 230000) {
            monthlySalesRange.value = `Over $${range.start}`
        } else {
            monthlySalesRange.value = `$${range.start} - $${range.end}`
        }
    } 
    return {
        monthlySalesRange,
        setMonthlySalesRange
    }
}

export default useRange